/**
 * GlobalBackupActivityDrawer (Spec 201) — one app-wide mount of the backup-activity
 * drawer, driven by the global store's `open` flag. Mounted once in AppLayout so a
 * backup/restore launched from ANYWHERE (a catalog, an entity page — outside the
 * Backup tab) immediately surfaces its live progress, not just inside /backup.
 *
 * Author: Peter Dobler (Dobler Data Solutions) · Feature 201
 */
import React from 'react';
import { useBackupActivity } from '../store/backupActivityStore';
import { BackupActivityDrawer } from './BackupActivityDrawer';

export const GlobalBackupActivityDrawer: React.FC = () => {
  const open = useBackupActivity((s) => s.open);
  const setOpen = useBackupActivity((s) => s.setOpen);
  return <BackupActivityDrawer isOpen={open} onClose={() => setOpen(false)} />;
};

export default GlobalBackupActivityDrawer;
